/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_RuianInputs */

const cs_kn_ruian = /** @type {(inputs: Kn_RuianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kód RÚIAN`)
};

const en_kn_ruian = /** @type {(inputs: Kn_RuianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN code`)
};

/**
* | output |
* | --- |
* | "RÚIAN code" |
*
* @param {Kn_RuianInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_ruian = /** @type {((inputs?: Kn_RuianInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_RuianInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_ruian(inputs)
	return cs_kn_ruian(inputs)
});